import FilterListIcon from "@mui/icons-material/FilterListRounded";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { getConditionsTooltip } from "../utils/statementOptions.ts";

interface Props {
  conditionCount: number;
  detailedView: boolean;
  onClick: (anchorEl: HTMLElement) => void;
}

const CardConditionsButton = ({ conditionCount, detailedView, onClick }: Props) => (
  <Tooltip title={getConditionsTooltip(conditionCount)}>
    <IconButton
      aria-label="Conditions"
      aria-haspopup="dialog"
      color={conditionCount > 0 ? "primary" : "secondary"}
      onClick={(event) => onClick(event.currentTarget)}
    >
      <Badge variant="dot" color="primary" invisible={detailedView || conditionCount === 0}>
        <FilterListIcon />
      </Badge>
    </IconButton>
  </Tooltip>
);

export default CardConditionsButton;
